<template>
  <div class="w-full">
    <file-pond

        :name="label"
        :ref="uniqueId"
        :label-idle="label"
        v-bind:allow-multiple="false"
        accepted-file-types="video/*"
        @init="handleFilePondInit"
        @addfile="oninitfileHandler"
        @removefile="onremovefile"
    />
  </div>
</template>

<script>
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond-plugin-media-preview/dist/filepond-plugin-media-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginMediaPreview from "filepond-plugin-media-preview";
const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginMediaPreview
);
export default {
  name: "upload-video",
  props: ["value"],
  data() {
    return {
      label:"Click or drag and drop to upload a video",
      uniqueId: '',
      video:null
    }
  },
  methods: {
    handleFilePondInit: function () {
      console.log("FilePond has initialized");
    },
    makeid: function (length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
      }
      return result;
    },
    oninitfileHandler: function (err) {
      if (err) return
      
      const file = this.$refs[this.uniqueId].getFiles()[0].file
      console.log()
      this.$emit('input', file);
    },
    onremovefile:function (err,data,dd){

      if (err) return
      this.$emit('input', null);
    }
  },
  components: {
    FilePond,
  },
  created() {
    this.uniqueId = this.makeid(10)
  }
}
</script>

<style scoped>

</style>